<template>
	<Col class="height-100 flex-centerize">
		<Row class="publishing-title mb-4">{{ isPublishCompleted ? 'Published' : 'Publishing...' }}</Row>
		<SIcon v-if="isPublishCompleted" :width="86" name="publish-completed" />
		<Col v-else>
			<SIcon name="empty-grey-circle" :width="86" />
			<Col class="lottie-container pa-3">
				<Lottie :width="66" :height="66" :options="animationOptions" />
			</Col>
		</Col>
		<Row class="might-take-text mt-4">This might take a few seconds</Row>
	</Col>
</template>
<script>
import Lottie from '@/assets/lottie/lottie.vue';
import PublishingAnimation from '@/components/Project/publishing-animation.json';

const PUBLISHED_COMPLETED_ANIMATION_LENGTH = 2000;

export default {
	name: 'PublishingAnimation',
	props: { isPublishCompleted: { type: Boolean } },
	components: { Lottie },
	computed: {
		animationOptions() {
			return { animationData: PublishingAnimation, loop: true, autoPlay: true };
		},
	},
	data: () => ({ showPublishCompletedAnimation: false }),
	watch: {
		isPublishCompleted(newVal, oldVal) {
			if (newVal && !oldVal) {
				this.showPublishCompletedAnimation = true;
			}
		},
		showPublishCompletedAnimation(val) {
			if (val) {
				setTimeout(() => {
					this.$emit('animation-completed');
					this.showPublishCompletedAnimation = false;
				}, PUBLISHED_COMPLETED_ANIMATION_LENGTH);
			}
		},
	},
};
</script>
<style scoped lang="scss">
.publishing-title {
	font-size: 20px;
	font-weight: 600;
	color: #262626;
	letter-spacing: 0px;
}
.might-take-text {
	font-size: 14px;
	color: #6b7786;
	letter-spacing: 0px;
}
.lottie-container {
	width: 86px;
	height: 86px;
	position: absolute;
}
</style>
